
import { FormCreateUpdateVehiculo } from '../../components';
import { DisenioPaginas } from '../../layout';
import moment from 'moment';



const now = moment().hours(0).minutes(0).seconds(0);
const initialState = {
    placa: "",
    modelo: "",
    conductor: "",
    soatInicio: now,
    tecnoInicio: now,
    todoRiesgoInicio: now,
};

export const CrearVehiculo = () => {



    return (

        <DisenioPaginas titulo="Crear Vehiculo" url={1} add={false} subtitulo="Información del vehiculo">
            <FormCreateUpdateVehiculo initialState={initialState} />
        </DisenioPaginas>
        
    )
}
